import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { TokenManager } from '@/lib/api-client'

/**
 * Handles the redirect from the backend Google OAuth callback.
 * Reads tokens from query params, stores them, and navigates to the dashboard.
 */
export function OAuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const processed = useRef(false)

  useEffect(() => {
    // Avoid double-processing in React StrictMode
    if (processed.current) return
    processed.current = true

    const access = searchParams.get('access')
    const refresh = searchParams.get('refresh')
    const error = searchParams.get('error')

    if (error) {
      // OAuth failed — send user to login with a message
      navigate('/login?error=google_auth_failed', { replace: true })
      return
    }

    if (access && refresh) {
      TokenManager.setTokens({ access, refresh })
      // Navigate to dashboard; replace history so back-button won't revisit this page
      navigate('/dashboard', { replace: true })
      return
    }

    // No tokens and no error — something went wrong
    navigate('/login?error=missing_tokens', { replace: true })
  }, [searchParams, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-2">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-gray-300 border-t-primary mx-auto" />
        <p className="text-sm text-muted-foreground">Completando autenticación...</p>
      </div>
    </div>
  )
}
